<template>
  <div class="linguasnapp">
    <div class="container">
      <div class="map-body">
        <LinguasnappNav id="linguasnapp-nav-top" />
        <div class="linguasnapp-introduction">
          <router-view class="text-content" />
          <LinguasnappNav id="linguasnapp-nav-right" />
        </div>
        <router-view name="content" />
        <LinkToStore class="mt-5" />
      </div>
    </div>
  </div>
</template>

<script>
import LinkToStore from '../instructions/LinkToStore';
import LinguasnappNav from './LinguasnappNav';

export default {
    name: 'Linguasnapp',
    components: { LinkToStore, LinguasnappNav },
};
</script>

<style scoped>
.linguasnapp {
  flex-direction: row;
  flex-grow: 1;
}

.linguasnapp-introduction {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 30px;
}

.map-body {
  padding: 0 20px;
}

#linguasnapp-nav-right {
  margin-left: 40px;
}

#linguasnapp-nav-top {
  display: none;
}

@media (max-width: 910px) {
  #linguasnapp-nav-right {
    display: none;
  }

  #linguasnapp-nav-top {
    display: flex;
  }
}

.text-content {
  width: 60%;
}

@media (max-width: 910px) {
  .text-content {
    width: 80%;
  }
}
</style>
